<div class="panneau-form-contact__container">
	<div class="container__content">
		<di-form-contacts [contact]="contact" context="panneau"></di-form-contacts>
	</div>
</div>